import * as S from './styles';
const ValueChangeCell = ({
  old_value,
  new_value
}) => {
  return <S.ValueContainer>
      {old_value === new_value ? <S.SameValueTableCell>{old_value}</S.SameValueTableCell> : <>
          <S.OldValueTableCell>{old_value}</S.OldValueTableCell>
          <S.NewValueTableCell>{new_value}</S.NewValueTableCell>
        </>}
    </S.ValueContainer>;
};
export default ValueChangeCell;